export default "__VITE_ASSET__CfMgkO0e__"